import sharedMessages from "../../../../shared-messages";
import { VALIDATION_ERROR_ISSUES } from "../../../../constants";
const { EMAIL_UNAVAILABLE, USERNAME_UNAVAILABLE } = VALIDATION_ERROR_ISSUES;

export default {
  [`email_${EMAIL_UNAVAILABLE}`]: sharedMessages.preexistingEmailAddress,
  [`userName_${USERNAME_UNAVAILABLE}`]: sharedMessages.preexistingUsername
};
